export const styles = {
  "header-container": ["container", "mx-auto", "py-5", "px-8"].join(" "),
  div: ["flex", "justify-between", "items-center"].join(" "),
};
